module.exports = __webpack_public_path__ + "static/media/digitalTransformation.2d0b4f48.svg";